export const types = {
  SET_WAREHOUSE_STORE: 'SET_WAREHOUSE_STORE',
}

const mutations = {
  [types.SET_WAREHOUSE_STORE]: (state, payload) => {
    Object.assign(state, {
      ...payload,
    })
  },
}

export default mutations
